<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                        
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'الصفوف'" :to="{name: 'groups'}">الصفوف</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'إضافة جديد'" :to="{name: 'groups.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                             <i class="flaticon-computer-4"></i> 
                                            بيانات الصف</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="store()">
                                    <div class="row">
                                         <div class="col-md-6">
                                              <label for="exampleFormControlInput12">الاسم</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                       
                                        <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.ar.name" placeholder=" الاسم ">
                                        <div class="invalid-feedback" :style="getErrors['ar.name'] ? 'display: block' : 'display: none;'"   v-if="getErrors['ar.name']">
                                              {{ getErrors['ar.name'][0] }}
                                        </div>
                                    </div>
                                     </div>

                                     <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة</label>
                                            <treeselect :options="data.options" :auto-load-root-options="true" v-model="data.form.stage_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                  <div class="col-md-6">
                                    <div class="form-group mb-4">
                                        <label for="exampleFormControlInput1">الحالة</label>
                                         <div class="row">
                                        <div class="custom-control col-md-6 custom-radio mb-3">
                                               <label class="new-control new-radio radio-primary" for="customRadio1">
                                          <input type="radio" id="customRadio1" name="customRadio"
                                           v-model="data.form.status" value="1" class="new-control-input">
                                       
                                                    <span class="new-control-indicator"></span>
                                              نشط</label>
                                      </div>
                                      <div class="custom-control col-md-6 custom-radio mb-4">
                                           <label class="new-control new-radio radio-danger" for="customRadio2">
                                          <input type="radio" id="customRadio2" name="customRadio"
                                           v-model="data.form.status" value="0" class="new-control-input">
                                         
                                               <span class="new-control-indicator"></span>
                                              غير نشط</label>
                                      </div>
                                      <div class="invalid-feedback" :style="getErrors['status'] ? 'display: block' : 'display: none;'"   v-if="getErrors['status']">
                                              {{ getErrors['status'][0] }}
                                        </div>
                                    </div>
                                     </div>
                                    </div>
                                      </div>
                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'groups'}">
                                      <span>رجوع</span>
                                    </router-link>
                                                          
                                </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      data: {
        checker: false,
        form:{
          ar: {name: ''},
          title: '',
          content: '',
          stage_id: '',
          status: 1
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
    this.getRequirements();
  },
  methods: {
      resetForm(){
        this.data.form = {
          ar: {name: ''},
          stage_id: '',
          status: 1
        };
      },
      getStages(){
        this.$baseApi.get('/groups/create?option=stage').then((response)=>{
            if(response.data.code == 200){
               this.data.options = response.data.data.options;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      store(){
          this.data.isRequested = true;
         this.$baseApi.post('/groups', this.data.form).then((response)=>{
            if(response.data.code === 200){
              localStorage.setItem('flash_message', 'تمت عملية الاضافة');
                router.push('/groups');
            }
        }).catch((error) => {
            this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
            this.data.isRequested = false
          })
      },
      getRequirements(){
        // this.getRoles();
        this.getStages();
      },
      getRoles(){
        this.$baseApi.get('/groups/create').then((response)=>{
            if(response.data.code == 200){
               this.data.roles = response.data.data.roles;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
  }
};
</script>
<style>
</style>
